
// src/App.js
import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import CustomerSegmentation from './pages/CustomerSegmentation';
import AgentStrategy from './pages/AgentStrategy';
import ProductRecommendation from './pages/ProductRecommendation';
import EBIGeneration from './pages/EBIGeneration';
import ProductComparison from './pages/ProductComparison';
import SummaryCreation from './pages/SummaryCreation';
import Unauthorized from './pages/Unauthorized'
import { ProgressProvider } from './context/ProgressContext';
import { AuthProvider } from './context/AuthContext';
import { UserProvider } from './context/UserContext';
import PrivateRoute from './components/PrivateRoute';
import './App.css';
import { useEffect } from "react";

const usePreventBackNavigation = () => {
    useEffect(()=>{
        const handlePopState = () =>{
            window.history.pushState(null, '', window.location.href);
        }
        window.history.pushState(null,'', window.location.href);
        window.addEventListener('popstate', handlePopState);
        return () =>{
            window.removeEventListener('popstate', handlePopState)
        }
    })
}
function App() {
  return (
    <AuthProvider>
      <UserProvider>
        <ProgressProvider>
          <Router>
            <AnimatePresence mode="wait">
              <Routes>
                {/* Public Route */}
                <Route path="/" element={<LoginPage />} />
                <Route path="/unauthorized" element = { <Unauthorized/>} />
                {/* Protected Routes */}
                <Route
                  path="/dashboard/*"
                  element={
                    <PrivateRoute>
                      <Dashboard />
                    </PrivateRoute>
                  }
                >
                  <Route path="customer-segmentation" element={<CustomerSegmentation />} />
                  <Route path="agent-strategy" element={<AgentStrategy />} />
                  <Route path="product-recommendation" element={<ProductRecommendation />} />
                  <Route path="ebi-generation" element={<EBIGeneration />} />
                  <Route path="product-comparison" element={<ProductComparison />} />
                  <Route path="summary-creation" element={<SummaryCreation />} />
                </Route>
              </Routes>
            </AnimatePresence>
          </Router>
        </ProgressProvider>
      </UserProvider>
    </AuthProvider>
  );
}
export default App;